import {
    createContext
} from "react";
import {
    NCoreUIKitTheme
} from "ncore-ui-kit";

export type DocsThemeName = "light" | "dark";

export type DocsThemePreference = DocsThemeName | "system";

export const DocsWidthContext = createContext(false);

export const useDocsLayout = () => {
    const {
        controlHeights,
        shapeConfigs,
        spaces
    } = NCoreUIKitTheme.useContext();

    return {
        maxWidth: shapeConfigs.drawerWidth + shapeConfigs.sideListWidth + shapeConfigs.contentMaxWidth + spaces.spacingXxl * 2,
        headerHeight: controlHeights.small + spaces.spacingMd * 2
    };
};

export const resolveTheme = (preference: DocsThemePreference): DocsThemeName => {
    if(preference !== "system") {
        return preference;
    }

    if(typeof window !== "undefined" && window.matchMedia("(prefers-color-scheme: dark)").matches) {
        return "dark";
    }

    return "light";
};
